import { schema } from "normalizr";

const companySchema = new schema.Entity("companies", { idAttribute: "id" });

export default companySchema;



// WEBPACK FOOTER //
// ./src/schemas/company.js